import { db } from "./db";
import type { WorkoutSession } from "./types";

function ensureHistorical(session: WorkoutSession) {
  if (session.status === "active") throw new Error("Une séance en cours ne peut pas être supprimée depuis l’historique.");
}

export async function deleteHistoricalSet(sessionId: string, performanceId: string, setId: string) {
  const session = await db.sessions.get(sessionId);
  if (!session) throw new Error("Séance introuvable.");
  ensureHistorical(session);
  const performance = session.performances.find((item) => item.id === performanceId);
  if (!performance) throw new Error("Exercice introuvable dans cette séance.");
  const nextSets = performance.sets.filter((set) => set.id !== setId);
  if (nextSets.length === performance.sets.length) throw new Error("Série introuvable.");
  const next = structuredClone(session);
  const nextPerformance = next.performances.find((item) => item.id === performanceId)!;
  nextPerformance.sets = nextSets;
  await db.sessions.put(next);
  return next;
}

export async function deleteHistoricalSession(sessionId: string) {
  const session = await db.sessions.get(sessionId);
  if (!session) throw new Error("Séance introuvable.");
  ensureHistorical(session);
  await db.sessions.delete(sessionId);
}
